import { Navigate } from "react-router-dom";
import { useAppSelector } from "@/redux/hooks";
import { loginSignupSelector } from "@/components/login-signup/LoginSignupSlice";

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * PublicRoute component - redirects authenticated users away from public routes like /login
 * Case 1: When user logs in successfully, they cannot go back to login page until logout
 
with refrence of last prompt , we have misside out some cases like:
1. If user open application in multiple tabs in single browser , if user sudenly logout from one tab then all tab logout will happen.
2. If user login from one tab in single borwser and he open muitple tabs then automaticaly that user will login shown in all the tabs, application will reload or track automaticaly this behaviuor of user.
Fallow all the isntruction of last prompt like create TODO lsit and achive desire goals etc.

*/
export const PublicRoute = ({ children }: PublicRouteProps) => {
  const { authenticated, token } = useAppSelector(loginSignupSelector);

  // If user is already authenticated, redirect to evaluate page
  if (authenticated && token) {
    return <Navigate to="/evaluate" replace />;
  }

  return <>{children}</>;
};
